module.exports = __webpack_public_path__ + "static/media/workingmemory-words-1.1d017997.mp3";